<template>
  <div class="web-message-packets-component">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 has-text-centered has-text-grey-dark dm-sans">
            Qual pacote de mensagem você gostaria?
          </p>
        </div>
      </div>
      <div class="columns mt-6">
        <div
            class="column is-half"
            v-for="(messagePacket, index) in formData.plan.data.messagePackets"
            :key="index"
        >
          <div
              class="is-flex is-justify-content-center is-full"
          >
            <div
                class="box is-size-3 mx-4 p-6 has-text-centered is-fullwidth"
                :class="{
                  'is-white is-outlined': formData.plan.data.seasonality !== 12 && messagePacket.mode === 2
                }"
            >
              <div class="columns">
                <div class="column is-12">
                  <h1 class="is-size-2 has-text-weight-bold">
                    <span v-if="messagePacket.mode === 2">
                      ILIMITADO
                    </span>
                    <span v-else>
                      PADRÃO
                    </span>
                  </h1>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full is-flex is-justify-content-center">
                  <div class="is-fit-width">
                    <div class="columns">
                      <div class="column" v-if="messagePacket.mode === 2">
                        <span class="has-text-grey-dark is-size-6 is-desktop is-pulled-left">R$</span>
                        <span class="is-size-2 has-text-weight-semibold has-text-black">
                           {{ messagePacket.originalPrice ?  formatPrice(messagePacket.originalPrice) : formatPrice(messagePacket.price)}}

                        </span>
                        <span class="has-text-grey-dark is-size-6">
                          /MÊS
                        </span>
                      </div>
                      <div v-else>
                        <div class="column pb-0 is-flex is-justify-content-center">
                          <span class="has-text-grey-dark is-size-6 is-desktop is-pulled-left">R$</span>
                          <span class="is-size-2 has-text-weight-semibold has-text-black">
                            {{ formatPrice(messagePacket.price) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <span v-if="messagePacket.mode === 2" class="tag is-primary is-small is-size-6">
                    POR CONEXÃO
                  </span>
                  <span v-else class="tag is-primary is-small is-size-6">
                    POR MENSAGEM ENVIADA
                  </span>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <button
                      v-if="formData.plan.data.seasonality !== 12 && messagePacket.mode === 2"
                      class="button is-primary is-inverted is-border is-size-5 is-medium has-text-weight-medium is-four-fifths disabled is-cursor-default"
                  >
                    <div class="is-fullwidth is-flex is-justify-content-center has-text-centered">
                      Apenas para planos anuais
                    </div>
                  </button>
                  <button
                      v-else
                      class="button is-primary is-size-5 is-medium has-text-weight-medium is-four-fifths"
                      @click.prevent="chooseMessagePacket(messagePacket)"
                  >
                    <div class="is-fullwidth">
                      Quero este
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 pt-6">
      <div class="columns">
        <div class="column is-full is-flex is-justify-content-start is-align-content-start">
          <button
              class="button is-primary is-size-4 is-large has-text-weight-medium is-one-third"
              @click.prevent="$emit('previousTab')"
          >
            <div class="is-fullwidth">
              <span class="is-justify-content-start is-align-content-start has-text-left is-pulled-left">
                <
              </span>
              Escolher outro plano
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { useAppStore } from "@/stores/AppStore";

export default {

  name: 'messagePackets',

  data() {
    return {
      originalPrice: null
    }
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  methods: {

    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },

    chooseMessagePacket(messagePacket) {
      if (!this.formData.messagePacket.data.originalPrice) {
        this.originalPrice = messagePacket.price
      }
      this.formData.messagePacket.hasSum = messagePacket.mode === 2
      this.formData.messagePacket.showStep = true
      this.formData.messagePacket.data = messagePacket
      this.formData.messagePacket.data.quantity = 1
      this.formData.messagePacket.data.originalPrice = this.originalPrice
      const appStore = useAppStore()
      appStore.showReviewNextButton = true
    }

  },

  mounted() {
    const appStore = useAppStore()
    appStore.showReviewNextButton = false
  }

}

</script>

<style lang="scss" scoped>
$box-color: #000;
</style>